<template>
  <div>
    <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
        <el-radio-button :label="false">展开</el-radio-button>
        <el-radio-button :label="true">收起</el-radio-button>
      </el-radio-group>
      <el-menu router default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse">
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span slot="title">教师管理</span>
          </template>
            <el-menu-item index="TeachersAll">教师基本信息</el-menu-item>
            <el-menu-item index="TeacherClass">教师所授课程</el-menu-item>
            <el-menu-item index="TeacherResourse">资源发布情况</el-menu-item>
        </el-submenu>
        <!-- // 2 学生管理 -->
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-menu"></i>
          <span slot="title">学生管理</span>
          </template>
          <el-menu-item index="StudentInfo">学生基本信息</el-menu-item>
          <el-menu-item index="StudentStudy">学生学情概况</el-menu-item>
        </el-submenu>


        <!-- <el-submenu index="3" disabled> -->
          <el-submenu index="3" >
          <template slot="title">
            <i class="el-icon-document"></i>
          <span slot="title">课程管理</span>
          </template>
          <el-menu-item index="CourseManage">课程管理</el-menu-item>
        </el-submenu>

        <el-submenu index="4" >
          <template slot="title">
            <i class="el-icon-setting"></i>
          <span slot="title">课堂分析</span>
          </template>
          <el-menu-item index="ClassAnalyse">实时课堂分析</el-menu-item>
          <el-menu-item index="CourseAnalyse">课程分析</el-menu-item>
        </el-submenu>
      </el-menu>
</div>
</template>
  <style>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 200px;
      min-height: 400px;
    }
  </style>
  
  <script>

    export default {
      data() {
        return {
          isCollapse: true
        };
      },
      methods: {
        handleOpen(key, keyPath) {
          console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
          console.log(key, keyPath);
        }
      }
    }
  </script>